import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteEmployee, getEmployees } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const UserList = () => {

    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleEmployees();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteEmployee(id, { archive: true });
            if (data.success) handleEmployees();
        } catch (err) { }
    };

    const handleEmployees = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };
            console.log("========== params", params)

            const { data } = await getEmployees(params);
            const { resultsPerPage, totalCount, employees, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(employees.map(employee => {
                return {
                    role: employee?.role?.name || '',
                    createdAt: employee?.createdAt,
                    email: employee?.email || '',
                    name: employee?.name || '',
                    _id: employee._id,
                }
            }));

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleEmployees(page);
    };

    const AddEmployee = () => navigate('/users/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_users',
                        title: 'user_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleEmployees,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_user',
                                action: AddEmployee,
                                icon: 'plus',

                            }
                        ]
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader
                            filter={{ isFilter: true, from: 'user' }}
                            applyFilter={handleEmployees}
                        />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={4}
                                type="users"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserList;